<template>
  <button
    v-if="visible"
    type="button"
    aria-label="Pledge to BF2026"
    class="block w-full overflow-hidden rounded-[12px]"
    @click="onTap"
  >
    <img :src="imageUrl" alt="" class="block h-auto w-full" @error="imageFailed = true" />
  </button>
</template>

<script>
import { BF_PLEDGE_ROUTES } from '@/constants/MyGiving/building-fund-pledge';
import { resolveBannerLink } from '@/utils/banner-link';

// BF2026 campaign banner on the MyGiving landing page: the artwork alone, the whole
// of it one button. The artwork is the CMS entry's bfBannerThumbnail, shown at its own
// aspect ratio so nothing is cropped; with no artwork, or artwork that fails to load,
// the banner is not shown at all.
//
// A tap goes to the CMS entry's bfBannerURL when it has one, routed the way every other
// pasted link is (resolveBannerLink): an in-app path stays in the app, anything else
// links out. With no link it opens the pledge: the form before a member has pledged,
// their pledge afterwards (the M frame links to V).
export default {
  name: 'BfPledgeBanner',

  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    hasPledge: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return { imageFailed: false };
  },

  computed: {
    visible() {
      return Boolean(this.imageUrl) && !this.imageFailed;
    },
  },

  watch: {
    imageUrl() {
      this.imageFailed = false;
    },
  },

  methods: {
    onTap() {
      if (this.url) {
        resolveBannerLink(
          { url: this.url },
          {
            router: this.$router,
            metadata: { title: 'BF Pledge Banner', source: 'my-giving-banner', page: 'MyGiving' },
          },
        );
        return;
      }
      this.$router.push(this.hasPledge ? BF_PLEDGE_ROUTES.view : BF_PLEDGE_ROUTES.form);
    },
  },
};
</script>
